import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { GraderGroup } from 'types/api';

type GetGraderGroupResponse = {
    grader_group: GraderGroup;
};

export const getGraderGroup = async (id: string): Promise<GraderGroup> => {
    const response = await api.get<
        GetGraderGroupResponse,
        GetGraderGroupResponse
    >(`/app/api/v1/grader_group/${id}`);
    return response.grader_group;
};

export const getGraderGroupQueryOptions = (id: string) => {
    return queryOptions({
        queryKey: ['graderGroup', id],
        queryFn: () => getGraderGroup(id),
    });
};

type UseGraderGroupOptions = {
    id: string;
    queryConfig?: QueryConfig<typeof getGraderGroupQueryOptions>;
};

export const useGraderGroup = ({ id, queryConfig }: UseGraderGroupOptions) => {
    return useQuery({
        ...getGraderGroupQueryOptions(id),
        ...queryConfig,
    });
};
